// src/constants.js
export const TYPE_MAP = {
    net: 'Net',
    gross: 'Gross'
};

export const TIE_BEHAVIOR_MAP = {
    split: 'Split Money Between Players',
    payAll: 'Pay All Players Full Amount',
    payNone: 'Dont Pay Ties'
};